import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import SuccessMessageContent from './SuccessMessageContent';
import clsx from "clsx";

export const SuccessMessageModal = React.forwardRef((props, ref) => {
  return (
    <Modal ref={ref} {...props} className={clsx('p-3', props.className)}>
      <SuccessMessageContent {...props} ref={ref}/>
    </Modal>
  );
});

SuccessMessageModal.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onAcceptAction: PropTypes.func
};

SuccessMessageModal.defaultProps = {

};

export default SuccessMessageModal;
